<template>
    <div>
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />

        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        (!integracao && !isUpdate && permissao.create) ||
                        (!integracao && isUpdate && permissao.update)
                    "
                    @click="save"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-4">
                    <v-input
                        :id="generateId(3)"
                        ref="idagro_ocorrenciaerpInput"
                        v-model="ocorrencia.idagro_ocorrenciaerp"
                        placeholder="placeholder-preencha"
                        :required="isUpdate"
                        :invalid="isUpdate && isNull(ocorrencia.idagro_ocorrenciaerp)"
                        :maxlength="30"
                        title="codigo"
                        uppercase
                        :tooltipLabel="isUpdate ? 'regra-prefixo-GA-edicao' : 'regra-prefixo-GA-criacao'"
                    />
                </div>
                <div class="column is-4">
                    <vss-select
                        :id="generateId(1)"
                        ref="tipoSelect"
                        title="tipo"
                        placeholder="selecione"
                        :options="tipoSelect"
                        v-model="tipoSelected"
                        :required="true"
                        :invalid="isNull(tipoSelected)"
                        tooltipLabel="informacao-tipoocorrencia"
                        tooltipPosition="is-top"
                        tooltipSize="is-small"
                        :disabled="cantEdit"
                        @onBlurFunction="sendIsChanged('tipoocorrencia')"
                    />
                </div>
                <div class="column is-4">
                    <vss-select
                        :id="generateId(2)"
                        ref="situacaoSelect"
                        title="situacao"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        class="no-clear"
                        :mlLabels="true"
                        :disabled="ocorrencia.idagro_ocorrencia == null || cantEdit"
                        @onBlurFunction="sendIsChanged('situacao')"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(5)"
                        ref="nomepopularInput"
                        v-model="ocorrencia.nomepopular"
                        placeholder="placeholder-preencha"
                        :maxlength="255"
                        title="nomepopular"
                        msg="msg-campo-obrigatorio"
                        :invalid="isNull(ocorrencia.nomepopular)"
                        :required="true"
                        tooltipLabel="informacao-ocorrencia-nomepopular"
                        tooltipPosition="is-top"
                        tooltipSize="is-small"
                        :disabled="cantEdit"
                    />
                </div>
                <div class="column is-6">
                    <v-input
                        :id="generateId(10)"
                        ref="nomecientificoInput"
                        v-model="ocorrencia.nomecientifico"
                        placeholder="placeholder-preencha"
                        :maxlength="255"
                        title="nomecientifico"
                        msg="msg-campo-obrigatorio"
                        :invalid="isNull(ocorrencia.nomecientifico)"
                        :required="true"
                        tooltipLabel="informacao-ocorrencia-nomecientifico"
                        tooltipPosition="is-top"
                        tooltipSize="is-small"
                        :disabled="cantEdit"
                    />
                </div>
            </div>
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <v-textarea
                        :id="generateId(15)"
                        ref="identificarField"
                        title="ocorrencia-identificar"
                        placeholder="placeholder-preencha"
                        v-model="ocorrencia.identificar"
                        :rows="5"
                        :maxRows="5"
                        :disableTransform="true"
                        :invalid="isNull(ocorrencia.identificar)"
                        :required="true"
                        tooltipLabel="informacao-ocorrencia-identificar"
                        tooltipPosition="is-top"
                        tooltipSize="is-small"
                        :disabled="cantEdit"
                        :maxlength="1000"
                    />
                </div>
                <div class="column is-6">
                    <v-textarea
                        :id="generateId(16)"
                        ref="perdasField"
                        title="ocorrencia-perdas"
                        placeholder="placeholder-preencha"
                        v-model="ocorrencia.perdas"
                        :rows="5"
                        :maxRows="5"
                        :disableTransform="true"
                        :invalid="isNull(ocorrencia.perdas)"
                        :required="true"
                        tooltipLabel="informacao-ocorrencia-perdas"
                        tooltipPosition="is-top"
                        tooltipSize="is-small"
                        :disabled="cantEdit"
                        :maxlength="1000"
                    />
                </div>
                <div class="column is-6">
                    <v-textarea
                        :id="generateId(18)"
                        ref="manejoField"
                        title="ocorrencia-manejo"
                        placeholder="placeholder-preencha"
                        v-model="ocorrencia.manejo"
                        :rows="5"
                        :maxRows="5"
                        :disableTransform="true"
                        :invalid="isNull(ocorrencia.manejo)"
                        :required="true"
                        tooltipLabel="informacao-ocorrencia-manejo"
                        tooltipPosition="is-top"
                        tooltipSize="is-small"
                        :disabled="cantEdit"
                        :maxlength="1000"
                    />
                </div>
                <div class="column is-6">
                    <v-textarea
                        :id="generateId(15)"
                        ref="controlarField"
                        title="ocorrencia-controlar"
                        placeholder="placeholder-preencha"
                        v-model="ocorrencia.controlar"
                        :rows="5"
                        :maxRows="5"
                        :disableTransform="true"
                        :invalid="isNull(ocorrencia.controlar)"
                        :required="true"
                        tooltipLabel="informacao-ocorrencia-controlar"
                        tooltipPosition="is-top"
                        tooltipSize="is-small"
                        :disabled="cantEdit"
                        :maxlength="1000"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OcorrenciaService from '@/services/agro/ocorrencia/OcorrenciaService';
import TipoOcorrenciaService from '@/services/agro/ocorrencia/TipoOcorrenciaService';
import OcorrenciaValidation from '@/services/validations/agro/OcorrenciaValidation';
import Message from '@/models/Message';

export default {
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('AGRO_OCORRENCIA'),
            service: new OcorrenciaService(this.$http, this.$router),
            serviceTipoOcorrencia: new TipoOcorrenciaService(this.$http, this.$router),
            validation: new OcorrenciaValidation(this.msgs),
            msgs: [],

            isLoading: false,
            isSaving: false,
            permissao: false,
            cantEdit: false,
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,

            ocorrencia: {
                idagro_ocorrencia: null,
                idagro_ocorrenciaerp: null,
                idagro_tipoocorrencia: null,
                nomepopular: null,
                nomecientifico: null,
                identificar: null,
                perdas: null,
                manejo: null,
                controlar: null,
                situacao: 1,
            },
            tipoSelect: [],
            tipoSelected: null,

            situacaoSelect: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacaoSelected: { label: 'ativo', id: 1 },

            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
            originalIdErp: ''
        };
    },
    watch: {
        ocorrencia: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit('isChanged', true);
                }
            },
        },
    },
    created() {
        setTimeout(() => {
            this.$emit('isChanged', false);
        }, 500);

        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-ocorrencia');
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-ocorrencia');
        }

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'ocorrencia' },
            });
        } else if (this.isUpdate) {
            this.cantEdit = !this.permissao.update;
            this.carregarDados();
        } else {
            this.loadTipo();
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-dados-cadastrais-' + numberId;
        },
        sendIsChanged(label) {
            setTimeout(() => {
                if (label == 'tipoocorrencia' && this.tipoSelected != null) {
                    this.ocorrencia.idagro_tipoocorrencia = this.tipoSelected.id;
                } else {
                    if (label == 'situacao' && this.situacaoSelected != null) {
                        this.ocorrencia.situacao = this.situacaoSelected.id;
                    }
                }
            }, 300);
        },
        save() {
            this.isLoading = true;
            if (this.validation.validate(this.ocorrencia, this.$refs)) {
                if(this.isPrefixSovisInIdErpInvalid(this.ocorrencia.idagro_ocorrenciaerp || '', this.originalIdErp)) {
                    const message = 
                        this.isUpdate ? 'nao-permitido-prefixo-ga-alterar' : 'nao-permitido-prefixo-ga-no-campo-codigo';
                    
                    this.isLoading = false;

                    return this.$root.showMessage('alert', message, true);
                }

                let ocorrenciaTemp = Object.assign({}, this.ocorrencia);
                ocorrenciaTemp = this.mapTosave(ocorrenciaTemp);

                this.isSaving = true;
                this.service
                    .save(ocorrenciaTemp, this.abrev)
                    .then((value) => {
                        if (value.message == null) {
                            let msg =
                                this.ocorrencia.idagro_ocorrencia != null
                                    ? 'msg-edit-ocorrencia'
                                    : 'msg-save-ocorrencia';

                            this.msgs.push(new Message('success', msg, true));

                            this.$emit('isChanged', false);

                            this.$emit('redirect', value.content.idagro_ocorrencia);
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (this.$te(e.body.message)) {
                            if (e.body.message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(e.body.message, 
                                            { n: ocorrenciaTemp.idagro_ocorrenciaerp }
                                        ),
                                        true,
                                        false
                                    )
                                );
                            } else if (e.body.message) {
                                this.msgs.push(new Message('alert', e.body.message, true));
                            }
                        } else {
                            console.error('Erro ao salvar: ' + e);
                            this.msgs.push(new Message('error', 'msg-erro-salvar', true));
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.runValidations();
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(this.$route.params.id, this.abrev)
                .then((value) => {
                    this.ocorrencia.idagro_ocorrencia = value.content.idagro_ocorrencia;
                    this.ocorrencia.idagro_ocorrenciaerp = value.content.idagro_ocorrenciaerp;
                    this.ocorrencia.idagro_tipoocorrencia = value.content.idagro_tipoocorrencia;
                    this.ocorrencia.nomepopular = value.content.nomepopular;
                    this.ocorrencia.nomecientifico = value.content.nomecientifico;
                    this.ocorrencia.identificar = value.content.identificar;
                    this.ocorrencia.perdas = value.content.perdas;
                    this.ocorrencia.manejo = value.content.manejo;
                    this.ocorrencia.controlar = value.content.controlar;
                    this.ocorrencia.situacao = value.content.situacao;

                    this.situacaoSelected = this.situacaoSelect[this.ocorrencia.situacao];

                    this.originalIdErp = this.ocorrencia.idagro_ocorrenciaerp;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.loadTipo();
                    setTimeout(() => {
                        this.$emit('isChanged', false);
                    }, 300);
                    this.runValidations(true);
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                    this.$emit('descricao', this.ocorrencia.nomecientifico);
                });
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
        },
        loadTipo() {
            this.serviceTipoOcorrencia
                .findAllCombo('')
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.id,
                            label: m.descricao,
                            cor: m.cor,
                            icone: m.icone.toLowerCase(),
                        };
                    });
                })
                .then((tipos) => {
                    this.tipoSelect = Object.assign(tipos);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (
                        this.tipoSelect.length > 0 &&
                        this.ocorrencia.idagro_tipoocorrencia != null &&
                        this.ocorrencia.idagro_tipoocorrencia != 0
                    ) {
                        this.tipoSelected = this.tipoSelect.filter((f) => {
                            return f.id == this.ocorrencia.idagro_tipoocorrencia;
                        })[0];
                    }
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>
